module.exports = __webpack_public_path__ + "static/media/login-green.972957ab.svg";